module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/babel-loader/lib/index.js!./FbtExemption.js"));
	}, "fbt");
}


//////////////////
// WEBPACK FOOTER
// ./src/features/fbt/driver/FbtExemption.js
// module id = 2004
// module chunks = 4